import { render, staticRenderFns } from "./ProfileSettingsCard.vue?vue&type=template&id=59932a6f&scoped=true&"
import script from "./ProfileSettingsCard.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingsCard.vue?vue&type=style&index=0&id=59932a6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59932a6f",
  null
  
)

export default component.exports